import { FC } from 'react';
import { Deferre } from '../domains/courses/services/enum';
import Box from '@mui/material/Box';

type FerrureIconSet = {
    anterieurs: string; // chemin ou nom du fichier SVG
    posterieurs: string;
};

const horseshoeIcons = {
    no_crossed: '/no_crossed.svg',
    crossed: '/crossed.svg',
    protected: '/protected.svg',
};

const getFerrureIcons = (deferre: Deferre): FerrureIconSet => {
    switch (deferre) {
        case Deferre.DEFERRE_POSTERIEURS:
            return {
                anterieurs: horseshoeIcons.no_crossed,
                posterieurs: horseshoeIcons.crossed,
            };

        case Deferre.DEFERRE_ANTERIEURS:
            return {
                anterieurs: horseshoeIcons.crossed,
                posterieurs: horseshoeIcons.no_crossed,
            };

        case Deferre.DEFERRE_ANTERIEURS_POSTERIEURS:
            return {
                anterieurs: horseshoeIcons.crossed,
                posterieurs: horseshoeIcons.crossed,
            };

        case Deferre.REFERRE_ANTERIEURS_POSTERIEURS:
            return {
                anterieurs: horseshoeIcons.no_crossed,
                posterieurs: horseshoeIcons.no_crossed,
            };

        case Deferre.PROTEGE_ANTERIEURS:
            return {
                anterieurs: horseshoeIcons.protected,
                posterieurs: horseshoeIcons.no_crossed,
            };

        case Deferre.PROTEGE_POSTERIEURS:
            return {
                anterieurs: horseshoeIcons.no_crossed,
                posterieurs: horseshoeIcons.protected,
            };

        case Deferre.PROTEGE_ANTERIEURS_DEFERRRE_POSTERIEURS:
            return {
                anterieurs: horseshoeIcons.protected,
                posterieurs: horseshoeIcons.crossed,
            };

        case Deferre.DEFERRE_ANTERIEURS_PROTEGE_POSTERIEURS:
            return {
                anterieurs: horseshoeIcons.crossed,
                posterieurs: horseshoeIcons.protected,
            };

        case Deferre.PROTEGE_ANTERIEURS_POSTERIEURS:
            return {
                anterieurs: horseshoeIcons.protected,
                posterieurs: horseshoeIcons.protected,
            };

        default:
            return {
                anterieurs: horseshoeIcons.no_crossed,
                posterieurs: horseshoeIcons.no_crossed,
            };
    }
};

interface Props {
    deferre: Deferre | null;
    isSecondary?: boolean
}

export const FerrureBox: FC<Props> = ({ deferre, isSecondary = false }) => {
    if (deferre) {
        const icons = getFerrureIcons(deferre);

        const primary = 'brightness(0) saturate(100%) invert(12%) sepia(22%) saturate(1327%) hue-rotate(177deg) brightness(92%) contrast(98%)'
        const secondary = 'brightness(0) saturate(100%) invert(49%) sepia(51%) saturate(567%) hue-rotate(111deg) brightness(98%) contrast(94%)'
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="row"
            >
                <img
                    src={`${icons.anterieurs}`}
                    alt="anterieur"
                    style={{ height: '20px', width: '20px', marginBottom: '5px', filter: isSecondary ? secondary : primary, }}

                />
                <img
                    src={`${icons.posterieurs}`}
                    style={{ height: '20px', width: '20px', filter: isSecondary ? secondary : primary }}
                />
            </Box>
        );
    } else {
        return null;
    }
};
